<template>
    <div class="middle-sidebar-content" ref="tags">
        <p class="subtitle middle-sidebar-title is-5 has-text-weight-bold">Tags</p>
        <div class="load"><span v-show="list.loading" class="loader"></span></div>

        <base-button
            @click="show_create_modal = true"
            :loading="create.loading"
            class="is-block themed-button"
            icon="fas fa-plus"
            text="Create Tag"/>

        <tag-item v-for="tag in list.data.results" :space="space" :tag="tag" :key="tag.id"/>

        <mugen-scroll
            :should-handle="!list.loading && !last_page"
            :handler="load"
            scroll-container="tags"
            ref="scroll">

            <p v-if="!last_page">loading...</p>
        </mugen-scroll>

        <tag-create-modal
            @close="show_create_modal = false"
            :show="show_create_modal"
            :space="space"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import inViewport from 'element-in-view';
import MugenScroll from 'vue-mugen-scroll';
import TagCreateModal from './TagCreateModal.vue';
import TagItem from './TagItem.vue';

export default {
    name: 'TagList',
    components: { TagCreateModal, TagItem, MugenScroll },
    props: ['space'],
    data() {
        return { page: 1, last_page: false, show_create_modal: false };
    },
    computed: {
        ...mapState('tags', ['list', 'create']),
    },
    methods: {
        async load() {
            await this.$store.dispatch('tags/list', {
                space_id: this.space.id,
                extend: this.page > 1,
                page: this.page,
            });

            this.page += 1;
            this.last_page = !this.list.data.next;

            // If marker (rel="scroll") in users display load second page
            if (inViewport(this.$refs.scroll.$el, { threshold: 0 }) && !this.last_page) {
                this.load();
            }
        },
    },
};
</script>

<style scoped>
    .load {
        position: absolute;
        padding-left: 0.5rem;
    }
</style>
